/**
 * @desc 保存
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.BaseUnitTypeDetailsResponseDto>;
export function request(
  body: defs.basics.BaseUnitTypeRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/baseUnitType/save`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
